import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.psl = bracketIndenting({
	line: "#",
})
